const ROLL_CALL_API_BASE_URL = "https://perecoapis.azurewebsites.net/";

// const ROLL_CALL_API_BASE_URL = "http://192.168.1.127:8080/";

const ROLL_CALL_IMG_PATH =
  "https://perecoapis.azurewebsites.net/portal/fileupload/empfiledownload?path=";

const NOTIFICATIONS_API =
  "https://notifyservisesrc.azurewebsites.net/notify/queuemail";
const ROLL_CALL_LOGIN = "portal/user/login";
const ROLL_CALL_EMPLOYEES_LIST = "portal/emp/getemployees";
const Bear_Token = "kbsakjdnlsajdsj";

export const getAuthToken = () => {
  return sessionStorage.getItem("authToken");
};

export const getSuperId = () => {
  return sessionStorage.getItem("superId");
};

export const getSessionData = () => ({
  token: sessionStorage.getItem("authToken"),
  superId: sessionStorage.getItem("superId"),
});

export {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_LOGIN,
  NOTIFICATIONS_API,
  ROLL_CALL_EMPLOYEES_LIST,
  Bear_Token,
  ROLL_CALL_IMG_PATH,
};
